import { render, staticRenderFns } from "./BankAccountsModalButton.vue?vue&type=template&id=0a3383de&scoped=true&"
import script from "./BankAccountsModalButton.vue?vue&type=script&lang=js&"
export * from "./BankAccountsModalButton.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountsModalButton.vue?vue&type=style&index=0&id=0a3383de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3383de",
  null
  
)

export default component.exports